<template>
  <router-view />
</template>
<script>
export default {
  name: "Pdf",
};
</script>

<style lang="scss">
/* containers/Pdf.vue */
@import "../assets/css/variables.scss";

$pdf-width: 298mm;
$pdf-height: 210.34mm;
$pdf-sidebar: 185px;

html,
body {
  // overflow: hidden;
}
.pdf-container {
  float: none;
  .pdf-page {
    width: $pdf-width;
    height: $pdf-height;
    position: relative;
    border: none;
    overflow: hidden;
    .page-number {
      position: absolute;
      right: 10px;
      bottom: 10px;
      z-index: 100;
      font-size: 0.8rem;
      border-radius: 50%;
      border: 1px solid #949290;
      width: 1.5rem;
      height: 1.5rem;
      text-align: center;
      background-color: #fff;
    }
  }
  .pdf-page-flex {
    display: flex;
  }
  .logo {
    background-color: $primary-color;
    padding-top: 60px;
    padding-bottom: 30px;
  }
  .info-company {
    background-color: #f5fafd;
    color: $primary-color !important;
    text-transform: uppercase;
    height: 475px;
    padding: 75px 0;
    h3 {
      font-size: 3.5rem;
      font-family: $font-title;
      padding-top: 50px;
      color: $primary-color !important;
    }
    h4 {
      font-size: 25px;
      font-family: $font-subtitle;
      color: $primary-color !important;
    }
    h5 {
      text-transform: initials;
      font-family: $font-text;
      color: $primary-color !important;
      text-align: center;
    }
  }
  .sidebar {
    padding: 10px;
    background-color: $primary-color;
    height: 100%;
    width: $pdf-sidebar;
    display: flex;
    flex-wrap: wrap;
    align-content: space-between;
    h2,
    h3 {
      text-align: center;
      text-transform: uppercase;
      color: #fff;
      font-family: $font-subtitle;
      font-size: 18px;
    }
    h3 {
      font-size: 15px;
    }
    &.second-color {
      background-color: $secondary-color;
    }
    .middle {
      width: 100%;
    }
    .bottom {
      width: 100%;
    }
  }
  .pillar-page .sidebar {
    h2 {
      font-size: 15px;
      margin-bottom: 30px;
    }
  }
  .content {
    padding: 10px;
    width: 975px;
    display: flex;
    .conventions {
      display: flex;
      flex-wrap: wrap;
      align-content: space-between;
      width: 180px;
    }
    .chart {
      width: 755px;
      margin-left: 20px;
    }
    .radar {
      width: 50%;
      margin-right: 10px;
    }
    .resume {
      width: 50%;
    }
  }
  .content-indicator {
    padding: 10px;
    width: 975px;
    display: flex;
    flex-direction: column;
    .block {
      width: 932px;
      display: flex;
      padding-bottom: 10px;
    }
    .content-card {
      width: 456px;
      height: 365px;
      margin-right: 10px;
    }
    .content-card-double {
      width: 100%;
      height: 365px;
      margin-right: 10px;
    }
    .conventions-2 {
      width: 25%;
    }
  }
}
.card {
  margin-top: 0px;
  .card-body {
    padding: 0.5rem;
  }
  .card-text {
    font-size: 0.9rem;
  }
}
</style>

<style type="text/css">
@page {
  size: A4 landscape;
  margin: 0;
}
@media print {
  body {
    -webkit-print-color-adjust: exact;
  }
  .pdf-container {
    float: none;
  }
  .pdf-page {
    margin: 0;
    border: initial;
    border-radius: initial;
    width: initial;
    height: initial;
    box-shadow: initial;
    background: initial;
    page-break-before: always;
  }
}
.top{
  margin-left:10px;
}
.bottom{
  margin-left:20px;
}
#companyName{
    color: $primary-color;
  text-align: center;
  }
</style>
